<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <div  class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Grade</th>
                <th>Marks</th>
                <th>Exam Date</th>
                <th>Remarks</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="(trainee_grade, index) in trainee_grades" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee_grade.grade }}</td>
                <td>{{ trainee_grade.marks }}</td>
                <td>{{ trainee_grade.exam_date }}</td>
                <td>{{ trainee_grade.remarks }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <h5 v-if="trainee_grades.length == 0" class="text-center text-secondary">
            No Data Found
          </h5>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/profile-layout";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";

export default {
  page: {
    title: "Trainee Exam Grade",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "Trainee Exam Grade",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee Exam Grade",
          active: true
        }
      ],
      flag: false,
      trainee_grades: [],
    };
  },


  mounted() {
    this.getTraineeGrade();
  },
  methods: {
    async getTraineeGrade() {
       let trainee_id = this.$route.params.trainee_id;
      await http.get("api/trainee/profile/grade/list/" + trainee_id)
          .then(resource => {
            this.trainee_grades = resource.data.trainee_grades
          })
          .catch(error => {
            console.log(error)
          })
    },
  },
};
</script>
